import { CollapsedRanksProps } from './props';
import { ranksColumns } from '@/constants/ranks-columns';
import styles from './styles.module.scss';
import { TableGrid } from '@starsoft/common/components';

export default function CollapsedRanks({ ranks }: CollapsedRanksProps) {
  return (
    <div className={styles.container}>
      <TableGrid rows={ranks} columns={ranksColumns} />
    </div>
  );
}
